import { Base } from "ui/Scripts/source/framework/base";

export interface ITaskHandler {
    id: string;
    userCode: string;
    userName: string;
    userPicture: string;
    modifyDate: number;

    isNew(): boolean;
}

export class TaskHandler implements ITaskHandler {
    id: string;
    userCode: string;
    userName: string;
    userPicture: string;
    modifyDate: number;

    constructor();
    constructor(obj: ITaskHandler);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.userCode = obj && obj.userCode || "";
        this.userName = obj && obj.userName || "";
        this.userPicture = obj && obj.userPicture || "";
        this.modifyDate = obj && obj.modifyDate || 0;
    }

    isNew(): boolean {
        return this.modifyDate === 0;
    }

    static sortTaskHandlers(items: ITaskHandler[]) {
        if (Base.isNullOrUndefined(items) || items.length < 2) return;
        const sortFunc = (a: ITaskHandler, b: ITaskHandler) => {
            if (Base.isNullOrUndefined(a) || Base.isNullOrUndefined(b)) return 0;
            return Base.strCompare(a.userName, b.userName);
        };
        items.sort(sortFunc);
    }

    static createTaskHandler(userCode: string, userName: string, userPicture: string): TaskHandler {
        const result = new TaskHandler();
        result.id = Base.getGuid();
        result.userCode = userCode;
        result.userName = userName;
        result.userPicture = userPicture;
        return result;
    }
}

export class SaveTaskHandler {
    id: string;
    userCode: string;
    modifyDate: number;

    constructor();
    constructor(obj: ITaskHandler);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.userCode = obj && obj.userCode || "";
        this.modifyDate = obj && obj.modifyDate || 0;
    }
}